import React from 'react'
import logo from '../../assets/image/logo.png';
import '@fortawesome/fontawesome-free/css/all.min.css';
import "../../pages/CoreValues.css";
import chessimg3 from '../../assets/image/chessimg3.jpeg'
import chessimg18 from '../../assets/image/chessimg18.jpeg'
import chessimg from '../../assets/image/chessimg.jpeg'
import chessimg14 from '../../assets/image/chessimg14.jpeg'
import anchitsir from '../../assets/image/anchitsir.jpeg'
import shreyanshsir from '../../assets/image/shreyanshsir.jpeg'

const About = () => {
    return (
        <div>
            <div id="preloader-active">
                <div className="preloader d-flex align-items-center justify-content-center">
                    <div className="preloader-inner position-relative">
                        <div className="preloader-circle"></div>
                        <div className="preloader-img pere-text">
                            <img src={logo} alt="Loading..." />
                        </div>
                    </div>
                </div>
            </div>

            <main>
                <div class="slider-area ">
                    <div
                        className="single-slider hero-overly slider-height d-flex align-items-center"
                        style={{
                            backgroundImage: `url(${chessimg3})`,
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                            height: '400px', // You can adjust height
                        }}
                    >
                        <div class="container">
                            <div class="row">
                                <div class="col-xl-12">
                                    <div class="hero-cap">
                                        <h2>About us</h2>
                                        <nav aria-label="breadcrumb">
                                            <ol class="breadcrumb">
                                                <li class="breadcrumb-item"><a href="index.html">Home</a></li>
                                                <li class="breadcrumb-item"><a href="#">About</a></li>
                                            </ol>
                                        </nav>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <br />
                <br />

                <div className="bg-white py-5">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div class="cl-xl-7 col-lg-8 col-md-10">

                                <div class="section-tittle text-center mb-70">
                                    <span>The values we never leave</span>
                                    <h2>Our Core Values!</h2>
                                </div>
                            </div>
                        </div>

                        <div className="row justify-content-center py-5">
                            <div className="col-lg-10">
                                <div className="row gy-5 gx-4">

                                    {/* Discipline towards Chess */}
                                    <div className="col-md-6 col-lg-4">
                                        <div className="value-item d-flex align-items-start">
                                            <div className="icon-box flex-shrink-0 me-3">
                                                <i className="fa-solid fa-chess"></i>
                                            </div>
                                            <div>
                                                <h5 className="fw-semibold text-dark mb-2">Discipline towards Chess!</h5>
                                                <p className="text-muted lh-base">
                                                    Chess requires diligent practice for excellence. Our faculty and students are
                                                    inspired to maintain high discipline towards chess.
                                                </p>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Commitment to the Vision */}
                                    <div className="col-md-6 col-lg-4">
                                        <div className="value-item d-flex align-items-start">
                                            <div className="icon-box flex-shrink-0 me-3">
                                                <i className="fa-solid fa-eye"></i>
                                            </div>
                                            <div>
                                                <h5 className="fw-semibold text-dark mb-2">Commitment to the Vision</h5>
                                                <p className="text-muted lh-base">
                                                    Every person working with KMCA has a single minded vision: to develop
                                                    children's intelligence through chess, and is entirely committed to this
                                                    vision.
                                                </p>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Professionalism in Sports */}
                                    <div className="col-md-6 col-lg-4">
                                        <div className="value-item d-flex align-items-start">
                                            <div className="icon-box flex-shrink-0 me-3">
                                                <i className="fa-solid fa-user-tie"></i>
                                            </div>
                                            <div>
                                                <h5 className="fw-semibold text-dark mb-2">Professionalism in Sports</h5>
                                                <p className="text-muted lh-base">
                                                    Today, sports is not considered a serious career option in the country. But at
                                                    KMCA, we believe in bringing the highest degree of professionalism in sport.
                                                </p>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Love for the Work */}
                                    <div className="col-md-6 col-lg-4">
                                        <div className="value-item d-flex align-items-start">
                                            <div className="icon-box flex-shrink-0 me-3">
                                                <i className="fa-solid fa-heart"></i>
                                            </div>
                                            <div>
                                                <h5 className="fw-semibold text-dark mb-2">Love for the Work</h5>
                                                <p className="text-muted lh-base">
                                                    At KMCA, our founders and faculty love the work they do. Every faculty member
                                                    loves the sport of chess and also the training of young kids.
                                                </p>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Care for the Stakeholder */}
                                    <div className="col-md-6 col-lg-4">
                                        <div className="value-item d-flex align-items-start">
                                            <div className="icon-box flex-shrink-0 me-3">
                                                <i className="fa-solid fa-hand-holding-hand"></i>
                                            </div>
                                            <div>
                                                <h5 className="fw-semibold text-dark mb-2">Care for the Stakeholder</h5>
                                                <p className="text-muted lh-base">
                                                    At KMCA, we are dedicated to taking care of all our stakeholders including our
                                                    students, their parents, partnering institutions, and our faculty.
                                                </p>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Integrity of the Self */}
                                    <div className="col-md-6 col-lg-4">
                                        <div className="value-item d-flex align-items-start">
                                            <div className="icon-box flex-shrink-0 me-3">
                                                <i className="fa-solid fa-suitcase"></i>
                                            </div>
                                            <div>
                                                <h5 className="fw-semibold text-dark mb-2">Integrity of the Self</h5>
                                                <p className="text-muted lh-base">
                                                    Nothing matters more to an organization than its integrity. We maintain the
                                                    highest levels of integrity in all our relationships.
                                                </p>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <br />
                <br />
                <br />
                <br />

                <div class="home-blog-area section-padding30">
                    <div class="container">


                        <div class="row">
                            <div class="col-lg-4 col-md-6">
                                <div class="home-blog-single mb-30">
                                    <div class="blog-img-cap">
                                        <div class="blog-img">
                                            <img src={chessimg18} alt="" />
                                        </div>
                                    </div>
                                    <div class="blog-caption">
                                        <div class="blog-date text-center">
                                            <span><i class="fa-sharp fa-solid fa-bullseye"></i></span>
                                        </div>
                                        <div class="blog-cap">


                                            <h3><a href="blog_details.html">Our Mission</a></h3>
                                            <p>
                                                To develop the next set of grandmasters
                                                from the countrty of India in a span of 7-8 years
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-6">
                                <div class="home-blog-single mb-30">
                                    <div class="blog-img-cap">
                                        <div class="blog-img">
                                            <img src={chessimg} alt="" />
                                        </div>
                                    </div>
                                    <div class="blog-caption">
                                        <div class="blog-date text-center">
                                            <span> <i class="fa-sharp fa-solid fa-crosshairs"></i></span>
                                        </div>
                                        <div class="blog-cap">

                                            <h3><a href="blog_details.html">Our Goal</a></h3>
                                            <p>
                                                To induct and introduce beginners to the world

                                                of chess and take them leaps forward
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-6">
                                <div class="home-blog-single mb-30">
                                    <div class="blog-img-cap">
                                        <div class="blog-img">
                                            <img src={chessimg14} alt="" />
                                        </div>
                                    </div>
                                    <div class="blog-caption">
                                        <div class="blog-date text-center">
                                            <span> <i class="fa-solid fa-eye"></i></span>
                                        </div>
                                        <div class="blog-cap">

                                            <h3><a href="blog_details.html">Our Vision</a></h3>
                                            <p>Develop a chess culture in India, leading
                                                to higher IQ and better future for children, society

                                                and the nation</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

               <div class="team-area section-padding30">
    <div class="container">
        <div class="row justify-content-center">
            <div class="cl-xl-7 col-lg-8 col-md-10">
                <div class="section-tittle text-center mb-70">
                    <span>Our Founders</span>
                    <h2>The Men Behind This!</h2>
                </div>
            </div>
        </div>
        <div class="row" style={{display: 'flex', justifyContent: 'center', flexWrap: 'nowrap'}}>
            <div class="col-lg-2 col-md-4 col-sm-12"></div>
            <div class="col-lg-4 col-md-4 col-sm-6" style={{flex: '1', minWidth: '0'}}>
                <div class="single-team mb-30 text-center">
                    <div class="team-img">
                        <img src={anchitsir} alt="" class="founder-img"
                            style={{ height: '400px', width: '330px', textAlign: 'center' }} />
                        <div class="team-caption text-center" style={{ marginLeft: '-50px' }}>
                            <br />
                            <h3 style={{ fontSize: '30px' }}>Anchit Mehta</h3>
                            <p>Chartered Accountant by
                                Educational Qualification <br /> Internationally rated chess player
                                by FIDE<br /> Personal Chess Coach since 7 years <br /> Mithibai College Chess
                                Captain</p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-4 col-sm-6" style={{flex: '1', minWidth: '0'}}>
                <div class="single-team mb-30 text-center">
                    <div class="team-img">
                        <img src={shreyanshsir} style={{ height: '400px', width: '300px' }}
                            alt="" class="founder-img" />
                        <div class="team-caption text-center"
                            style={{ height: '400px', width: '330px', textAlign: 'center' }}
                        >
                            <br />
                            <h3 style={{ fontSize: '30px' }}
                            >Shreyans Mehta </h3>
                            <p>MBA from IIM Calcutta <br />BE from Thadomal Shahani
                                Engineering College <br />Consultant for McKinsey & Co<br />Co-Founder of Narendra
                                Modi's
                                professional campaign team CAG </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-2 col-md-4 col-sm-12"></div>
        </div>
    </div>
</div>
            </main>



            <div id="back-top" style={{ textAlign: 'center' }}>
                <a title="Go to Top" href="#" style={{ display: 'inline-block' }}>
                    <i className="fas fa-level-up-alt"></i>
                </a>
            </div>
        </div>

    )
}

export default About